import { useParams, Switch } from "react-router-dom"
import { SessionContextProvider } from "@/contexts/SessionContext"
import React from "react"
import PHLayout from "@/features/PHLayout"
import { RouteWithSubRoutes } from "@/utils/routerHelper"
import { RouteInput } from "@/types/route"
import { IntercomWrapper } from "@/features/Intercom"

export const SessionLayout = ({ routes }: { routes: RouteInput[] }) => {
  const { customerId } = useParams()

  return routes ? (
    <SessionContextProvider customerId={customerId}>
      <PHLayout customerId={customerId}>
        <IntercomWrapper />
        <Switch>
          {routes.map((route: RouteInput, i: number) => {
            return <RouteWithSubRoutes key={i} {...route} />
          })}
        </Switch>
      </PHLayout>
    </SessionContextProvider>
  ) : (
    <SessionContextProvider>
      <div>loading</div>
    </SessionContextProvider>
  )
}
